import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { compose, isEmpty, get } from '@carecloud/cloudpak';
import { graphql, withApollo } from 'react-apollo';
import * as CryptoJS from 'crypto-js';
import { connect } from 'react-redux';
import { store } from '../../../models';
import { AcceptConnectInvite, changePassword, GetUserToken, RecoverPassword, ResetPassword, UpdateSecureAccountTwoFA, SendLoginOtp, VerifyLoginOtp, UpdatePasswordOtp, signInResendOTP } from '../../../graphql/mutations';
import { GetLogin, GetSettings } from '../../../graphql/queries';
import { isMobileDevice, getMobileDevice, breakBackButton } from '../../services/utilities';
import { Session, Routing, SchemaParser } from '../../services';
import Login from './Login';
import { Utilities } from '../../../constants';
import { parseParams } from '../../services/routing';
import { ContextProvider } from '../../root/TopLevelContext';
import { loginContext as LoginContext } from '../../../contexts';
import ToastContainer from '../../modals/toast/toastContainer';

class LoginContainer extends Component {
  static contextType = ContextProvider;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadCheckmarkComplete: false,
      loadCrossIncomplete: false,
      checkmark: false,
      cross: false,
      errorMessage: null,
      inviteCode: null,
      otpModal: null,
      signInCodeUsernames: {},
      signInCodeOtps: {},
      // id_token issued by verifyLoginOtp for the forgotPassword flow, keyed
      // by the new-password modal id — needed by updatePasswordOtp, and not
      // available anywhere else since this flow doesn't call Session.setSession.
      signInCodeIdTokens: {},
      signInSession: {},
      // Which option is selected in the "Add a verification step" modal —
      // matches the radio option that's checked by default in the schema.
      verificationMethod: 'phone',
      loginCredentials: {
        email: '',
        password: '',
      },
      otp: '',
    };

    const {
      location: { search = '', hash },
    } = this.props;
    if (search.includes('source=portal') || hash.includes('source=portal')) {
      store.dispatch.login.activateAlternateView('patientPortal');
    } else if (search.includes('confirmation_code')) {
      isMobileDevice() && store.dispatch.login.createNewPasswordFlowDisplay();
      store.dispatch.login.createNewPasswordView();
    } else if (search.includes('i')) {
      const queryString = new URLSearchParams(search);
      this.state.inviteCode = queryString.get('i');
    } else {
      (_ => {
        const { images = [] } = this.props.rightSide;
        if (images.length > 1) {
          let imageIndex = 1; // start from 2nd slide as 1st is always predefined
          this.sliderIntervalId = setInterval(_ => {
            if (imageIndex === images.length) imageIndex = 0;
            store.dispatch.login.changePicture(images[imageIndex], imageIndex !== 3);

            imageIndex++;
          }, 5000);
        }
      })();
    }
    sessionStorage.removeItem('CC-Breeze-Web-persistedGuestData');
  }
  componentDidMount() {
    this.generateUuid();
    this.context._setActions({
      changeLanguage: this.changeLanguage,
      checkForEmptyInput: this.checkForEmptyInput,
      checkForEmptyInputEmail: this.checkForEmptyInputEmail,
      RecoverEmail: this.RecoverEmail,
      checkSignInWithCodeInput: this.checkSignInWithCodeInput,
      checkSignInWithCodeOtp: this.checkSignInWithCodeOtp,
      checkFindAccountOtp: this.checkFindAccountOtp,
      sendFindAccountCode: this.sendFindAccountCode,
      sendSignInCode: this.sendSignInCode,
      resendSignInCode: this.resendSignInCode,
      verifySignInCode: this.verifySignInCode,
      continueAfterSignIn: this.continueAfterSignIn,
      dismissLoaderAndNavigate: this.dismissLoaderAndNavigate,
      checkNewPassword: this.checkNewPassword,
      checkConfirmPassword: this.checkConfirmPassword,
      updatePasswordOtp: this.updatePasswordOtp,
      forgotShowPassword: this.forgotShowPassword,
      passwordShow: this.passwordShow,
      passwordShowByName: this.passwordShowByName,
      passwordShownBtn: this.passwordShownBtn,
      passwordButtonShow: this.passwordButtonShow,
      authPasswordShow: this.authPasswordShow,
      showAddVerificationStep: this.showAddVerificationStep,
      selectVerificationMethod: this.selectVerificationMethod,
      checkVerificationInput: this.checkVerificationInput,
      sendVerificationCode: this.sendVerificationCode,
      checkVerificationCode: this.checkVerificationCode,
      resendLoginOtp: this.resendLoginOtp,
      verifyLoginOtp: this.verifyLoginOtp,
      useDifferentVerificationMethod: this.useDifferentVerificationMethod,
      finishSecureAccountSetup: this.finishSecureAccountSetup,
      finishChangePassword: this.finishChangePassword,
      // overwrite: true — _setActions otherwise only registers a key the
      // FIRST time it's ever seen (see TopLevelContext.jsx), so if this
      // component ever remounts (e.g. hot-reload in dev), a stale, unmounted
      // instance's bound methods could keep "winning" the registration for
      // some keys while a newer instance wins others — different handlers
      // silently operating on different `this.state` objects. Forcing every
      // key here to always point at whichever instance is currently mounted
      // keeps them all consistent with each other.
    }, { overwrite: true });
    breakBackButton();
  }
  componentDidUpdate() {
    this.passwordShownBtn();
    this.checkPasswordRequirements();
    // secureAccountIntro is now the shared front door for both the password
    // reset + 2FA flow and the 2FA-only flow — only mention the "create a
    // new password" step when show_reset_popup means it'll actually happen.
    const passwordFeature = document.getElementById('secureAccountPasswordFeature');
    if (passwordFeature) {
      passwordFeature.style.display = JSON.parse(sessionStorage.getItem('show_reset_popup')) ? '' : 'none';
    }
    // secureAccountFlowDisplay (dispatched from finishChangePassword) mounts
    // the SecureAccount screen async — addVerificationStep isn't in the DOM
    // yet on the same tick as the dispatch, so the skip-the-intro swap has
    // to wait for the render it causes to actually commit.
    if (this.skipToAddVerificationStep && document.getElementById('addVerificationStep')) {
      this.revealAddVerificationStep();
      this.skipToAddVerificationStep = false;
    }

    if (this.skipToVerificationCompleteStep && document.getElementById('verificationComplete')) {
      this.revealVerificationCompleteStep();
      this.skipToVerificationCompleteStep = false;
    }

    const { login, getLogin, error } = this.props;
    if (isEmpty(login.screens) && !getLogin.loading) {
      const loginScreens = get(getLogin, 'getLogin');
      loginScreens && store.dispatch.login.fetchStart(loginScreens);
      if (get(getLogin, 'getLogin.whiteLabelColor', String())) {
        store.dispatch.login.activateAlternateView('whiteLabelPortal');
      }
    }
    this.parseParams(this.props);
    if (error.errors) {
      store.dispatch.error.resetError();
      this.setState({ errorMessage:this.props.error.errors[0].message}); //eslint-disable-line react/no-did-update-set-state
      if( this.props.error.errors[0].message ==="Attempt limit exceeded, please try after some time."){
        this.crossComplete();
      }else{
        this.checkmarkComplete();
      }
      login.recoverPasswordCheckmark &&
        setTimeout(() => {
          store.dispatch.login.showCheckmark(false);
          this.setState({ errorMessage: null });
          isMobileDevice() && store.dispatch.login.createNewPasswordFlowDisplay();
        }, 5000);
    }
  }
  componentWillUnmount() {
    clearInterval(this.sliderIntervalId);
  }

  // Detects whether a user has reached the login page from a successful mobile signup
  isMobileSignup = _ => window.location.href.includes('?redirect=mobileSignup');

  parseParams = nextProps => {
    const params = Routing.parseParams(nextProps);
    if (params.action) {
      this[params.action](params.id);
    }
  };
  handleSubmit = async e => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    store.dispatch.error.resetError();
    this.setState(prevState => {
      return {
        ...prevState,
        loginCredentials: {
          email,
          password,
        },
      };
    });
    store.dispatch.button.enableButton({
      btn: 'twofaResendBtn',
      complete: false,
    });
    this.generateUuid();
    this.getCognitoPayload(email, password);
  };

  generateUuid = () =>{
    let uuid;
    if(!localStorage.getItem('device_identifier')){
       uuid =crypto.randomUUID();
      localStorage.setItem('device_identifier',uuid);
    }
  }
  getCognitoPayload = async (email, password, otp = null, device_identifier = localStorage.getItem('device_identifier')) => {
    const { location, history } = this.props;
    const { inviteCode } = this.state;
    let path = location.search ? location.pathname + location.search : location.pathname;
    sessionStorage.setItem('path', path)
    try {
      store.dispatch.login.showSignInError(false);
      // Enable page loader
      this.setState({ loading: true });
      const { data } = await this.props.client.mutate({
        mutation: GetUserToken,
        variables: {
          email,
          password,
          ...(otp && { otp }),
          device_identifier,
        },
      });
      if (data.getUserToken?.data?.show2faPopup) {
        store.dispatch.dashboard.showTwofaPopup(true);
      }
      if (data.getUserToken?.otpModal) {
        this.setState({ otpModal: data.getUserToken.otpModal });
        store.dispatch.modal.toggleOpen('signInOTPModal');
        this.setState({ loading: false });
        return;
      }
      const totalPractices = data.getUserToken?.data.practiceInformation.length;
      let executionValue = "";
      if (data?.getUserToken?.data?.practiceInformation?.[0].cloverapi === true) {
        executionValue = "cloverapi";
      } else if (data?.getUserToken?.data?.practiceInformation?.[0].payeezy === true) {
        executionValue = "payeezy";
      }else{
        executionValue = 'no-value'
      }
      sessionStorage.setItem('Patient-Ids-List', JSON.stringify(data.getUserToken?.data.patient_ids_list));
      sessionStorage.setItem('totalPractice', JSON.stringify(data.getUserToken?.data.practiceInformation.length));
      sessionStorage.setItem('singleSelectedpractice', JSON.stringify(data.getUserToken?.data.practiceInformation?.[0].practice_id));
      sessionStorage.setItem('execution', executionValue);
      sessionStorage.setItem('practiceSelectedMgmt', data.getUserToken?.data.practiceInformation?.[0].practice_mgmt);
      sessionStorage.setItem('isBreezePatient', data.getUserToken?.data?.isBreezePatient)
      const patientId = JSON.parse(sessionStorage.getItem('Patient-Ids-List'))?.[0]?.patient_id;
      const practiceMgmt = JSON.parse(sessionStorage.getItem('Patient-Ids-List'))?.[0]?.practice_mgmt;
      const practiceId = JSON.parse(sessionStorage.getItem('Patient-Ids-List'))?.[0]?.practice_id;
      if (totalPractices > 1) {
        store.dispatch.login.setSelectPractice(data.getUserToken.data.selectPracticeSchema);
      }
      const {
        getUserToken: {
          data: {
            cognitoPayload,
            cognitoPayload: { accessToken, authenticationToken, refreshToken },
            show_reset_popup,
            needsTwoFaSetup,
          },
        } = {},
      } = data;
      if (authenticationToken) store.dispatch.modal.toggleClose(false);

      Session.setSession(cognitoPayload);

      if (inviteCode) {
        const inviteResponse = await this.props.client.mutate({
          mutation: AcceptConnectInvite,
          variables: { inviteCode },
        });
        const {
          data: { acceptConnectInvite: { payload: { invite_info: inviteData } = {}, labels = {} } = {} } = {},
        } = inviteResponse;
        if (inviteData) {
          if (isMobileDevice()) {
            sessionStorage.clear();
            this.setState({ connectedToMultiProviders: true, loading: false });
            return true;
          } else {
            store.dispatch.notification.open({ data: inviteData, labels });
          }
        }
      }
      if (!inviteCode && cognitoPayload && cognitoPayload.authenticationToken) {
         const { data: { getSettings: encryptedData } }  = await this.props.client.query({
          query: GetSettings,
          variables: { input: { withSchema: false ,  patientId, practiceMgmt, practiceId  } },
        });
        const bytes = CryptoJS.AES.decrypt(encryptedData.encryptedData, 'sparrow');
        const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        const {
              payload: {
                user_links: { represented_users = [] } = {},
                demographics: {
                  payload: {
                    personal_details: {
                      gender,
                      date_of_birth,
                      ethnicity,
                      primary_race: race,
                      preferred_language: language,
                    },
                  },
                },
              },
        } = data
        if (represented_users.length) {
          const cognitoTokens = {
            email,
            accessToken,
            authenticationToken,
            refreshToken,
          };
          store.dispatch.login.storeCognitoToken(cognitoTokens);
          path = '/delegateProfile';
          sessionStorage.setItem('path', path)
        }
        store.dispatch.mixpanel.addMetadata({
          loginSuccess: true,
          baseProperties: { gender, date_of_birth, ethnicity, race, language },
        });
      }
      // if(show_reset_popup && needsTwoFaSetup) {
      //   this.setState({ loading: false });

      //   sessionStorage.setItem('show_reset_popup', true)
      //   sessionStorage.setItem('needsTwoFaSetup', true)
      //   store.dispatch.login.secureAccountFlowDisplay();
      // } 
      if(show_reset_popup) {
        this.setState({ loading: false });
        // Both this and needsTwoFaSetup land on the same shared
        // secureAccountIntro card first — showAddVerificationStep (the
        // "Get started" click) branches on this flag to route to
        // ChangePassword.ts's stepper instead of addVerificationStep when a
        // password reset is actually required.
        sessionStorage.setItem('show_reset_popup', true)
        if(needsTwoFaSetup) sessionStorage.setItem('needsTwoFaSetup', true)
        store.dispatch.login.secureAccountFlowDisplay();
      } else if (needsTwoFaSetup) {
        this.setState({ loading: false });
        sessionStorage.setItem('needsTwoFaSetup', true)
        store.dispatch.login.secureAccountFlowDisplay();
      } else if (totalPractices > 1) {
        // Disable page loader
        this.setState({ loading: false });
        store.dispatch.login.selectPracticeView();
      } else if(sessionStorage.getItem("practiceSelectedMgmt") === 'wellsoft') {
        history.push('/my_health')
      } else {
        sessionStorage.setItem('show_reset_popup', false)
        sessionStorage.setItem('needsTwoFaSetup', false)
        history.push(path);
        return true;
      }
    } catch (error) {
      sessionStorage.clear();
      console.error(error);
      store.dispatch.login.showSignInError(true);
      // Disable page loader
      this.setState({ loading: false });
      return false;
    }
  };

  revealVerificationCompleteStep = () => {
    const addVerificationStep = document.getElementById('addVerificationStep');
    const enterVerificationCode = document.getElementById('enterVerificationCode');
    const step = document.getElementById('verificationComplete');
    if(addVerificationStep) addVerificationStep.style.display = 'none';
    if (enterVerificationCode) enterVerificationCode.style.display = 'none';
    if (step) step.style.display = 'flex';
  };

  // SecureAccount.ts emits both the intro content and the "add a
  // verification step" content in the same card — this just swaps which one
  // is visible in place, same idea as sendSignInCode's advanceToEnterCode,
  // rather than opening a separate modal. Split out from showAddVerificationStep
  // so finishChangePassword's deferred landing (componentDidUpdate) can reach
  // this directly, without re-triggering the show_reset_popup redirect below
  // (show_reset_popup is still 'true' at that point — the password step is
  // already done, not still pending).
  revealAddVerificationStep = () => {
    const intro = document.getElementById('secureAccountIntro');
    const step = document.getElementById('addVerificationStep');
    if (intro) intro.style.display = 'none';
    if (step) step.style.display = 'flex';
    if(document.getElementById('addVerificationStepEmailInput') !== null) {
      const input = document.getElementById('addVerificationStepEmailInput')
      input.value = sessionStorage.getItem('CC-Breeze-Web-username')
      input.setAttribute('disabled', 'true')
    }
  };

  // Shared secureAccountIntro's "Get started" — routes to ChangePassword's
  // stepper first when a password reset is still required (show_reset_popup),
  // otherwise reveals addVerificationStep in place.
  showAddVerificationStep = () => {
    if (sessionStorage.getItem('show_reset_popup') === 'true') {
      store.dispatch.login.secureAccountFlowDisplay();
      store.dispatch.login.changePasswordFlowDisplay();
      return;
    }
    if(document.getElementById('addVerificationStepEmailInput') !== null) {
      const input = document.getElementById('addVerificationStepEmailInput')
      input.value = sessionStorage.getItem('CC-Breeze-Web-username')
     }
    this.revealAddVerificationStep();
  };

  // Both radio options post to the same mutation, distinguished by
  // `channel`. Toggles which of the two Inputs is visible/relevant — same
  // technique the existing twofaPhoneInputWrapper/twofaEmailInputWrapper
  // toggle already uses (radioInputContainer.jsx) — rather than relabeling
  // one shared input, so each Input's own built-in label+required-asterisk
  // (input.jsx) always match the field it actually belongs to.
  selectVerificationMethod = channel => {
    this.setState({ verificationMethod: channel });
    const phoneWrapper = document.getElementById('addVerificationStepPhoneWrapper');
    const emailWrapper = document.getElementById('addVerificationStepEmailWrapper');
    if (channel === 'email') {
      if (phoneWrapper) phoneWrapper.style.display = 'none';
      if (emailWrapper) emailWrapper.style.display = 'flex';
      store.dispatch.button.enableButton({ btn: 'addVerificationStepSendBtn', complete: true });
    } else {
      if (emailWrapper) emailWrapper.style.display = 'none';
      if (phoneWrapper) phoneWrapper.style.display = 'flex';
      store.dispatch.button.enableButton({ btn: 'addVerificationStepSendBtn', complete: false });
    }
  };

  checkVerificationInput = ({ value }) => {
    const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/i;
    const phoneRegex = /^\+?[0-9()\-\s]{12,}$/;
    const complete =
      (this.state.verificationMethod || 'phone') === 'email' ? emailRegex.test(value) : phoneRegex.test(value);
    store.dispatch.button.enableButton({ btn: 'addVerificationStepSendBtn', complete });
  };

  // "i•••@proton.me" / "(•••) •••-4567" — same idea as sendSignInCode's
  // earlier destination masking, just covering both channels here.
  maskDestination = (channel, value) => {
    if (channel === 'email') {
      const [user, domain = ''] = value.split('@');
      return `${user[0] || ''}${'•'.repeat(Math.max(user.length - 1, 0))}@${domain}`;
    }
    const digits = value.replace(/\D/g, '');
    return digits.length >= 4 ? `(•••) •••-${digits.slice(-4)}` : value;
  };

  // Builds the shared updateSecureAccountTwoFA input — same shape
  // ProfileSettingsContainer.updateTwoFA sends (do not touch that existing
  // settings-page flow; this calls a separate mutation/resolver/service).
  // `enabled` is hardcoded true (this flow's whole point is turning 2FA on).
  // Note: unlike phone (which carries phone_number), twoFASelection has no
  // custom-email-destination field — enabling verification_type: 'email'
  // verifies via whatever email is already on the account, not necessarily
  // what the user just typed into addVerificationStepEmailInput.
  buildTwoFactorInput = (channel, destination, otp = null) => ({
    enabled: true,
    settingsList: [
      { enabled: channel === 'email', verification_type: 'email' },
      {
        enabled: channel === 'phone',
        verification_type: 'sms',
        ...(channel === 'phone' && { phone_number: destination.replace(/\D/g, '') }),
      },
    ],
    ...(otp && { otp }),
  });

  // Phase 1: send the code. Unlike the settings-page flow (which only gets
  // an otp_sent round-trip for sms; email updates silently) this always
  // waits for otp_sent before advancing, since entering a code is the point
  // of this flow regardless of channel. Whether the real backend actually
  // sends an email OTP (vs. only ever having been exercised for sms) isn't
  // something cyclops/wolverine can guarantee — only the client-side gate
  // that used to hide that path has been removed.
  sendTwoFactorCode = async (channel, destination) => {
    try {
      const { data } = await this.props.client.mutate({
        mutation: UpdateSecureAccountTwoFA,
        variables: { input: this.buildTwoFactorInput(channel, destination) },
      });

      if (data.updateSecureAccountTwoFA?.otp_sent){
        store.dispatch.button.enableButton({
          btn: 'addVerificationStepSendBtn',
          complete: false,
        });
        return { data: { sent: true, bypass: false} }
      } else if (data?.updateSecureAccountTwoFA?.payload?.enabled !== undefined ) {
        // TODO: Get toast message from cyclops
        // store.dispatch.toast.open({ message: 'Two factor authentication preference updated', type: 'success'})
        return { data: {sent: true, bypass: true} }
      }
      // return;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  sendVerificationCode = async () => {
    this.setState({ loading: true });

    const channel = this.state.verificationMethod || 'phone';
    const input = document.getElementById(
      channel === 'email' ? 'addVerificationStepEmailInput' : 'addVerificationStepPhoneInput',
    );
    const username = input && input.value;
    if (!username) return;
    const data = await this.sendTwoFactorCode(channel, username);

    if (data.data.sent && data.data.bypass){
      this.skipToVerificationCompleteStep = true;
      this.revealVerificationCompleteStep();
    }
    else this.showEnterVerificationCode(channel, username);


    this.setState({ loading: false });
    this.setState({ verifiedDestination: username });

    // if(JSON.parse(sessionStorage.getItem('needsTwoFaSetup')))
    //   this.skipToAddVerificationStep = true;
    // else
    //   this.skipToVerificationCompleteStep = true;

  };

  // Same in-place swap as showAddVerificationStep — addVerificationStep ->
  // enterVerificationCode, no modal/route change.
  showEnterVerificationCode = (channel, destination) => {
    const step = document.getElementById('addVerificationStep');
    const enterCode = document.getElementById('enterVerificationCode');
    const description = document.getElementById('enterVerificationCodeDescription');
    if (step) step.style.display = 'none';
    if (enterCode) enterCode.style.display = 'flex';
    if (description) {
      const verb = channel === 'email' ? 'emailed' : 'texted';
      description.textContent = `We ${verb} a 5-digit code to ${this.maskDestination(
        channel,
        destination,
      )}. It expires in 5 minutes.`;
    }
  };

  checkVerificationCode = ({ value }) => {
    this.setState({ verificationCode: value });
    store.dispatch.button.enableButton({ btn: 'enterVerificationCodeVerifyBtn', complete: value.length === 5 });
  };

  resendLoginOtp = async () => {
    const channel = this.state.verificationMethod || 'phone';
    const username = this.state.verifiedDestination;
    if (!username) return;
    await this.sendTwoFactorCode(channel, username);
  };

  // Phase 2: verify. Same mutation as sendTwoFactorCode, this time with
  // `otp` populated — per the backend contract, a wrong/expired code comes
  // back without a `status` field at all (see LoginService.updateSecureAccountTwoFA),
  // so checking for status === 200 doubles as "verified". Only reveals the
  // "You're all set" screen — finishSecureAccountSetup (the Go-to-dashboard
  // button) is what actually navigates.
  verifyLoginOtp = async () => {
    this.setState({ loading: true });

    const code = this.state.verificationCode || '';
    if (code.length !== 5) return;
    const channel = this.state.verificationMethod || 'phone';
    const destination = this.state.verifiedDestination || '';
    try {
      const { data } = await this.props.client.mutate({
        mutation: UpdateSecureAccountTwoFA,
        variables: { input: this.buildTwoFactorInput(channel, destination, code) },
      });
      if (data?.updateSecureAccountTwoFA?.status !== 200) return;
    } catch (error) {
      console.error(error);
      return;
    } finally {
      this.setState({ loading: false });
    }
    const enterCode = document.getElementById('enterVerificationCode');
    const complete = document.getElementById('verificationComplete');
    const channelText = document.getElementById('verificationCompleteMethodChannel');
    const destinationText = document.getElementById('verificationCompleteMethodDestination');
    if (enterCode) enterCode.style.display = 'none';
    if (complete) complete.style.display = 'flex';
    if (channelText) channelText.textContent = channel === 'email' ? 'email' : 'text message';
    if (destinationText) destinationText.textContent = `to ${this.maskDestination(channel, destination)}`;
  };

  // Resumes whatever getCognitoPayload would otherwise have done once
  // needsTwoFaSetup routed here instead of continuing — path was already
  // stashed there.
  finishSecureAccountSetup = () => {
    this.setState({ loading: true });
    setTimeout(() => this.setState({ loading: false }), 50)

    store.dispatch.login.secureAccountFlowDisplay();
    sessionStorage.setItem('show_reset_popup', false)
    sessionStorage.setItem('needsTwoFaSetup', false)

    // this.props.history.push(sessionStorage.getItem('path') || '/dashboard');
    if (JSON.parse(sessionStorage.getItem('totalPractice')) > 1) {
        // Disable page loader
        this.setState({ loading: false });
        store.dispatch.login.selectPracticeView();
      } else if(sessionStorage.getItem("practiceSelectedMgmt") === 'wellsoft') {
        this.props.history.push('/my_health')
      } else {
        this.props.history.push(sessionStorage.getItem('path'));
        return true;
      }
  };

  // Advances step 1 (ChangePassword.ts) of the wizard to step 2, the
  // existing SecureAccount card — same swap finishSecureAccountSetup does
  // at the other end of the flow. The real password-change mutation still
  // runs independently off the native form submit (this button stays
  // type=submit), this only handles the screen swap. Unlike the sign-in
  // flow's needsTwoFaSetup path (which should land on the intro), the user's
  // already past that context here, so skip straight to addVerificationStep
  // — flagged for componentDidUpdate since the screen isn't mounted yet.
  finishChangePassword = () => {
    this.setState({ loading: true });
    setTimeout(() => this.setState({ loading: false }), 50)

    store.dispatch.login.changePasswordFlowDisplay();
    store.dispatch.login.secureAccountFlowDisplay();
    if(JSON.parse(sessionStorage.getItem('needsTwoFaSetup')))
      this.skipToAddVerificationStep = true;
    else
      this.skipToVerificationCompleteStep = true;
  };

  useDifferentVerificationMethod = () => {
    const step = document.getElementById('addVerificationStep');
    const enterCode = document.getElementById('enterVerificationCode');
    if (enterCode) enterCode.style.display = 'none';
    if (step) step.style.display = 'flex';
    store.dispatch.button.enableButton({ btn: 'addVerificationStepSendBtn', complete: true });
  };

  handleSubmitOTP = () => {
    const {
      loginCredentials: { email, password },
      otp,
      device_identifier,
    } = this.state;
    this.setState(prevState => {
      return {
        ...prevState,
        otp: null,
      };
    });
    this.getCognitoPayload(email, password, otp,device_identifier);
  };

  changeLanguage = language => {
    if (localStorage.getItem('CC-Breeze-Web-language') === language) {
      store.dispatch.dropdown.toggleOpen('loginLanguageMenu');
      return;
    }
    localStorage.setItem('CC-Breeze-Web-language', language);
    window.location.reload();
  };
  checkmarkComplete = _ => {
    this.setState({ loadCheckmarkComplete: true, checkmark: true });
  };
  crossComplete = _ => {
    this.setState({ loadCrossIncomplete: true, cross: true });
  };
  resetState = _ => {
    this.setState({
      loadCheckmarkComplete: false,
      checkmark: false,
      loadCrossIncomplete: false,
      cross: false,
    });
    store.dispatch.login.showResetPasswordCheckmark(false);
    store.dispatch.login.showRequestSuccess(false);
  };
  RecoverEmail = ({ value }) => {
    const regex = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
    if (value.length === 0 || regex.test(value) === false) {
      store.dispatch.button.enableButton({
        btn: 'recoverPasswordBtn',
        complete: false,
      });
    } else {
      store.dispatch.button.enableButton({
        btn: 'recoverPasswordBtn',
        complete: true,
      });
    }
  };

  // Same enable/disable idea as RecoverEmail, but this field takes email OR
  // mobile number, and two modals (signInWithCode, forgotPasswordCode) share
  // this trigger — so the button to enable is derived from the input's own
  // id (`...Input` -> `...SendBtn`) instead of a single hardcoded name.
  checkSignInWithCodeInput = ({ id, value }) => {
    const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/i;
    const phoneRegex = /^\+?[0-9()\-\s]{10,}$/;
    store.dispatch.button.enableButton({
      btn: id.replace(/Input$/, 'SendBtn'),
      complete: value.length > 0 && (emailRegex.test(value) || phoneRegex.test(value)),
    });
  };
  // Same enable/disable idea as checkSignInWithCodeInput, but for the OTP
  // box: distinct from checkForEmptyInputOTP, which is hardcoded to a
  // 5-digit check against the unrelated 2FA modal's verify button.
  checkSignInWithCodeOtp = ({ id, value }) => {
    const modalId = id.replace(/OtpInput$/, '');
    // See signInCodeOtps in the constructor — verifySignInCode can't read
    // this back off the DOM, since the "otp" input type is 6 separate boxes
    // and only the first carries this id.
    this.setState(prevState => ({
      signInCodeOtps: { ...prevState.signInCodeOtps, [modalId]: value },
    }));
    store.dispatch.button.enableButton({
      btn: `${modalId}VerifyBtn`,
      complete: /^\d{6}$/.test(value),
    });
  };

  checkFindAccountOtp = ({ id, value }) => {
    const modalId = id.replace(/OtpInput$/, '');
    
    this.setState(prevState => ({
      signInCodeOtps: { ...prevState.signInCodeOtps, [modalId]: value },
    }));

    store.dispatch.button.enableButton({
      btn: `${modalId}VerifyBtn`,
      complete: /^\d{6}$/.test(value),
    });
  }

  maskEmail = value => {
    if (!value) return null;
    const [user, domain = ''] = value.split('@');
    const [domainName, ...tld] = domain.split('.');
    const maskedUser = user.length > 1 ? `${user[0]}${'•'.repeat(user.length - 1)}` : user;
    const maskedDomain = domainName.length > 1 ? `${domainName[0]}${'•'.repeat(domainName.length - 1)}` : domainName;
    return `${maskedUser}@${maskedDomain}.${tld.join('.')}`;
  };
  maskPhone = value => {
    const digits = `${value || ''}`.replace(/\D/g, '');
    if (digits.length < 4) return null;
    return `(•••) •••-${digits.slice(-4)}`;
  };

  // findAccountModal's "Send code" button — same wiring shape as
  // sendSignInCode below (a localActions call carrying whatever cyclops
  // already resolved, e.g. nextModalId), but there's no input field on this
  // step to read a value from: the destination is whichever Text me/Email me
  // SelectionCard is selected. `radioInput[groupName]` gives the method
  // ('text'/'email'); `radioInput[`${groupName}FullValue`]` gives that
  // card's real, unmasked destination (SelectionCard.jsx stores it alongside
  // value — the rendered `description` is masked, e.g.
  // "a••@m•••••••••.com"). Follows the RecoverPassword blueprint
  // sendSignInCode was built on: best-effort send via loginService.sendOTP,
  // advancing regardless of outcome so the modal doesn't get stuck for
  // reasons the user can't see.
  sendFindAccountCode = async ({ groupName, nextModalId }) => {
      store.dispatch.loader.persistLoader({ persist: true });
    const method = store.getState().radioInput[groupName];
    const username = store.getState().radioInput[`${groupName}FullValue`];
    if (!method || !username) return;
    try {
      const { data } = await this.props.client.mutate({
        mutation: SendLoginOtp,
        variables: { username, device_identifier: localStorage.getItem('device_identifier'), flow: 'find_account' },
      });
      // On success, sendOTP returns the "enter code" step rebuilt with the
      // masked destination the code was actually sent to — same swap-in
      // mechanism findAccountModalFormGroup's response already uses for
      // findAccountVerifyModal (see login.setModalSchema / SchemaParser's
      // MODAL case).
      const findAccountEnterCodeModal = get(data, 'sendLoginOtp.findAccountEnterCodeModal');
      if (findAccountEnterCodeModal) {
        sessionStorage.removeItem('CC-Breeze-Web-otpSession');
        this.setState(prevState => ({
          signInCodeUsernames: { ...prevState.signInCodeUsernames, [nextModalId]: username },
          signInSession: { ...prevState.signInSession, session: data?.sendLoginOtp?.data?.payload?.session },
        }));
        store.dispatch.login.setModalSchema({ modalId: nextModalId, schema: findAccountEnterCodeModal });
        store.dispatch.modal.toggleOpen(nextModalId);
      }
    } catch (error) {
      console.error(error);
    } finally {
      store.dispatch.loader.persistLoader({ persist: false });
    }
  };

  // The sign-in-with-code modal's "Send code" button lives inside a Modal,
  // which portals outside the page's <form> — so unlike recoverPasswordBtn
  // (a real type="submit" inside that form), it needs its own click action
  // reading the field value straight from the DOM by id.
  //
  // nextModalId comes from cyclops (generateSignInWithCodeModal already
  // resolves signInWithCode -> signInWithCodeEnterCodeModal vs forgotPassword
  // -> forgotPasswordEnterCodeModal) so this doesn't have to guess/hardcode
  // which flow it's in.
  sendSignInCode = async ({ inputId, nextModalId }) => {
    const input = document.getElementById(inputId);
    const value = input && input.value;
    if (!value) return;
    const advanceToEnterCode = () => {
      store.dispatch.modal.toggleOpen(nextModalId);
      // The "Enter your code" description is baked in at schema-generation
      // time and can't know what the user typed, so patch it in directly —
      // same direct-DOM-update style checkForEmptyInput already uses. The
      // enter-code modal is a separate Modal from the one this button lives
      // in, so it isn't mounted until the toggleOpen above commits — defer a
      // tick so its description element actually exists to patch.
      setTimeout(() => {
        const description = document.getElementById(`${nextModalId}StepDescription`);
        if (description) description.textContent = `Sent to ${this.maskEmail(value)}. expires in 5 min`;
      }, 0);
    };
    // persistLoader is set/cleared in a try/finally so it can never get stuck
    // on `true` — every branch below used to reset it individually, and it
    // was easy to miss one (a stuck loader renders a full-screen overlay in
    // Layout.jsx that blocks all further clicks, including retrying).
    store.dispatch.loader.persistLoader({ persist: true });
    try {
      const { data } = await this.props.client.mutate({
        mutation: SendLoginOtp,
        variables: { username: value, device_identifier: localStorage.getItem('device_identifier'), flow: 'forgot_password' },
      });
      if (data.sendLoginOtp.status === 200) {
        // Persisted here (not read back off the DOM) because step 1's Modal
        // — and this Input along with it — is unmounted the moment
        // advanceToEnterCode() below opens step 2's Modal instead.
        // Clear any session stashed by errorLink from a previous, unrelated
        // attempt — verifySignInCode prefers that stashed value over state,
        // so leaving it behind here would make a brand-new code verify
        // against a stale Cognito challenge session instead of this fresh one.
        sessionStorage.removeItem('CC-Breeze-Web-otpSession');
        this.setState(prevState => ({
          signInCodeUsernames: { ...prevState.signInCodeUsernames, [nextModalId]: value },
          signInSession: { ...prevState.signInSession, session: data?.sendLoginOtp?.data?.payload?.session },
        }));
        advanceToEnterCode();
      } else {
        console.error('sendSignInCode: unexpected response', data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      store.dispatch.loader.persistLoader({ persist: false });
    }
  };
  // "Resend code" on the sign-in-with-code/forgotPassword/find-account
  // enter-code step. Not resendOTP (that sends signInResendOTP, which needs
  // a password this flow doesn't have) — reuses the same SendLoginOtp
  // mutation sendSignInCode/sendFindAccountCode already call, with the
  // username they stored in signInCodeUsernames under this same modal id,
  // passing along whichever flow ('forgot_password' or 'find_account') this
  // modal was actually opened under instead of assuming forgot_password.
  //
  // Mirrors each one's on-success handling (refreshing signInSession so
  // verifySignInCode checks the new code against the new Cognito challenge
  // session rather than the stale one, and — for find_account — swapping in
  // the refreshed findAccountEnterCodeModal schema) since a resend otherwise
  // silently regenerates the session server-side without this state ever
  // catching up.
  resendSignInCode = async ({ id: modalId, flow }) => {
    const username = this.state.signInCodeUsernames[modalId];
    if (!username) return;
    // Disable immediately on click, not gated on the mutation resolving —
    // this is also what the Timer (autoRestart: true, ModalParser.ts) watches
    // to restart its own countdown, so the visible timer and the disabled
    // state always change together regardless of how long the request takes.
    store.dispatch.button.enableButton({ btn: `${modalId}ResendBtn`, complete: false });
    try {
      const { data } = await this.props.client.mutate({
        mutation: SendLoginOtp,
        variables: { username, device_identifier: localStorage.getItem('device_identifier'), flow },
      });
      if (flow === 'find_account') {
        const findAccountEnterCodeModal = get(data, 'sendLoginOtp.findAccountEnterCodeModal');
        if (!findAccountEnterCodeModal) {
          console.error('resendSignInCode: unexpected response', data);
          return;
        }
        sessionStorage.removeItem('CC-Breeze-Web-otpSession');
        this.setState(prevState => ({
          signInCodeUsernames: { ...prevState.signInCodeUsernames, [modalId]: username },
          signInSession: { ...prevState.signInSession, session: data?.sendLoginOtp?.data?.payload?.session },
        }));
        store.dispatch.login.setModalSchema({ modalId, schema: findAccountEnterCodeModal });
      } else {
        if (data.sendLoginOtp.status !== 200) {
          console.error('resendSignInCode: unexpected response', data);
          return;
        }
        sessionStorage.removeItem('CC-Breeze-Web-otpSession');
        this.setState(prevState => ({
          signInCodeUsernames: { ...prevState.signInCodeUsernames, [modalId]: username },
          signInSession: { ...prevState.signInSession, session: data?.sendLoginOtp?.data?.payload?.session },
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

    // Calls the dedicated verify_login_otp mutation (a separate mutation from
  // GetUserToken/getCognitoPayload, not a reuse of it). nextModalId (from
  // generateSignInWithCodeModal) is either the new-password modal
  // (forgotPassword flow — verifying the code just unlocks that step, it
  // doesn't sign the user in) or the success modal directly (signInWithCode
  // flow, where the code verification *is* the sign-in — the response
  // mirrors GetUserToken's shape, so the same completion steps run here,
  // duplicated rather than shared so this stays independent of that flow).
  verifySignInCode = async ({ otpInputId, nextModalId }) => {
    // `signInWithCodeModalOtpInput` -> `signInWithCodeModal`. This is the
    // same enter-code modal id sendSignInCode/checkSignInWithCodeOtp stored
    // the username/otp under — read from state, not the DOM: the "otp" input
    // type renders as 6 separate single-digit boxes, and only the first one
    // carries this id, so document.getElementById(otpInputId).value would
    // only ever return that one digit instead of the full code.
    const modalId = otpInputId.replace(/OtpInput$/, '');
    const otp = this.state.signInCodeOtps[modalId];
    if (!otp) return;
    const username = this.state.signInCodeUsernames[modalId];
    if (!username) return;

    const { location } = this.props;
    const { inviteCode } = this.state;
    let path = location.search ? location.pathname + location.search : location.pathname;
    // persistLoader is set/cleared in a try/finally so it can never get stuck
    // on `true` — every branch below used to reset it individually, and it
    // was easy to miss one (a stuck loader renders a full-screen overlay in
    // Layout.jsx that blocks all further clicks, including retrying Verify —
    // this is why the mutation would sometimes appear to "not be called").
    store.dispatch.loader.persistLoader({ persist: true });
    try {
      const { data } = await this.props.client.mutate({
        mutation: VerifyLoginOtp,
        variables: {
          username,
          otp,
          device_identifier: localStorage.getItem('device_identifier'),
          // ApolloClient.js's errorLink nulls out response.errors on every
          // GraphQL error before this promise resolves, so a wrong code
          // never throws here — it just resolves with verifyLoginOtp: null.
          // That means Cognito's replacement challenge session (parsed out
          // of the failed attempt's error data) can only be picked up from
          // where errorLink stashed it, not from a caught exception here.
          session: sessionStorage.getItem('CC-Breeze-Web-otpSession') || this.state.signInSession.session,
        },
      });
      const tokenData = data.verifyLoginOtp;
      if (tokenData?.otpModal) {
        // Response shape mirrors sign_in's, so this can technically come
        // back, though it shouldn't for a flow that's already code-based.
        this.setState({ otpModal: tokenData.otpModal });
        store.dispatch.modal.toggleOpen('signInOTPModal');
        return;
      }
      if (nextModalId.includes('NewPassword')) {
        if (data.verifyLoginOtp.data.status === 200) {
          // updatePasswordOtp needs this later, keyed by the same modal id it
          // reads it back under — this flow never calls Session.setSession, so
          // it's not available anywhere else.
          const idToken = tokenData?.data?.cognitoPayload?.authenticationToken;
          if (idToken) {
            this.setState(prevState => ({
              signInCodeIdTokens: { ...prevState.signInCodeIdTokens, [nextModalId]: idToken },
            }));
          }
          store.dispatch.modal.toggleOpen(nextModalId);
        } else {
          store.dispatch.toast.open({ type: 'error', message: 'Enter the 6-digit code we sent you.' });
        }
        return;
      }
      // signInWithCode/find_account: verifying the code *is* completing sign-in
      // (there's no separate password step after this). A wrong code resolves
      // here too (verifyLoginOtp doesn't throw for that — it comes back null,
      // not merely status !== 200) rather than reaching any of the
      // GetUserToken-shaped data below, so it needs its own explicit failure
      // message instead of silently falling through.
      if (!tokenData || tokenData.data.status !== 200) {
        store.dispatch.toast.open({ type: 'error', message: 'That code didn\'t work. Please try again.' });
        return;
      }
      // tokenData?.data.practiceInformation.length used to throw when this
      // passwordless response didn't carry every field GetUserToken's does —
      // the exception landed in the catch below with no user-facing feedback,
      // which looked exactly like "verify wasn't called". Optional-chained
      // throughout now, and the totalPractices/show_reset_popup/wellsoft
      // routing that used to run immediately after is deferred to
      // continueAfterSignIn (the success screen's Continue button) — this
      // function's job now is just to land on the success modal, not decide
      // where the user goes after acknowledging it.
      const totalPractices = tokenData?.data?.practiceInformation?.length || 0;
      let executionValue = "";
      if (tokenData?.data?.practiceInformation?.[0]?.cloverapi === true) {
        executionValue = "cloverapi";
      } else if (tokenData?.data?.practiceInformation?.[0]?.payeezy === true) {
        executionValue = "payeezy";
      } else {
        executionValue = 'no-value'
      }
      sessionStorage.setItem('Patient-Ids-List', JSON.stringify(tokenData?.data?.patient_ids_list || []));
      sessionStorage.setItem('totalPractice', JSON.stringify(totalPractices));
      sessionStorage.setItem('singleSelectedpractice', JSON.stringify(tokenData?.data?.practiceInformation?.[0]?.practice_id));
      sessionStorage.setItem('execution', executionValue);
      sessionStorage.setItem('practiceSelectedMgmt', tokenData?.data?.practiceInformation?.[0]?.practice_mgmt);
      sessionStorage.setItem('isBreezePatient', tokenData?.data?.isBreezePatient)
      const patientId = JSON.parse(sessionStorage.getItem('Patient-Ids-List'))?.[0]?.patient_id;
      const practiceMgmt = JSON.parse(sessionStorage.getItem('Patient-Ids-List'))?.[0]?.practice_mgmt;
      const practiceId = JSON.parse(sessionStorage.getItem('Patient-Ids-List'))?.[0]?.practice_id;
      if (totalPractices > 1) {
        store.dispatch.login.setSelectPractice(tokenData.data.selectPracticeSchema);
      }
      const {
        data: {
          cognitoPayload,
          cognitoPayload: { accessToken, authenticationToken, refreshToken } = {},
          show_reset_popup,
        } = {},
      } = tokenData;

      Session.setSession(cognitoPayload);

      if (inviteCode) {
        const inviteResponse = await this.props.client.mutate({
          mutation: AcceptConnectInvite,
          variables: { inviteCode },
        });
        const {
          data: { acceptConnectInvite: { payload: { invite_info: inviteData } = {}, labels = {} } = {} } = {},
        } = inviteResponse;
        if (inviteData) {
          if (isMobileDevice()) {
            sessionStorage.clear();
            this.setState({ connectedToMultiProviders: true });
            return true;
          } else {
            store.dispatch.notification.open({ data: inviteData, labels });
          }
        }
      }
      if (!inviteCode && cognitoPayload && cognitoPayload.authenticationToken) {
        const { data: { getSettings: encryptedData } } = await this.props.client.query({
          query: GetSettings,
          variables: { input: { withSchema: false, patientId, practiceMgmt, practiceId } },
        });
        const bytes = CryptoJS.AES.decrypt(encryptedData.encryptedData, 'sparrow');
        const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        const {
          payload: {
            user_links: { represented_users = [] } = {},
            demographics: {
              payload: {
                personal_details: {
                  gender,
                  date_of_birth,
                  ethnicity,
                  primary_race: race,
                  preferred_language: language,
                },
              },
            },
          },
        } = decrypted
        if (represented_users.length) {
          const cognitoTokens = {
            email: username,
            accessToken,
            authenticationToken,
            refreshToken,
          };
          store.dispatch.login.storeCognitoToken(cognitoTokens);
          path = '/delegateProfile';
          sessionStorage.setItem('path', path)
        }
        store.dispatch.mixpanel.addMetadata({
          loginSuccess: true,
          baseProperties: { gender, date_of_birth, ethnicity, race, language },
        });
      }
      // show_reset_popup/totalPractices/wellsoft used to route immediately
      // here, before the user ever saw a success screen. Persisted for
      // continueAfterSignIn to read instead — verifying the code always lands
      // on the success modal now; Continue decides where to go from there.
      sessionStorage.setItem('show_reset_popup', JSON.stringify(!!show_reset_popup));
      sessionStorage.setItem('path', path);
      store.dispatch.modal.toggleOpen(nextModalId);
    } catch (error) {
      // A wrong/expired code resolves above (tokenData null) rather than
      // throwing — errorLink (ApolloClient.js) nulls out response.errors on
      // every GraphQL error before this promise settles, and also parses the
      // replacement Cognito session out for the next attempt from there,
      // since this catch never sees that payload. This block is left for
      // genuine exceptions (network errors, etc.).
      this.setState({signInCodeOtps: {}})
      console.error(error);
    } finally {
      this.setState({signInCodeOtps: {}})
      store.dispatch.loader.persistLoader({ persist: false });
    }
  };
  // "Continue" on the sign-in-with-code/find-account success screen. Reads
  // what verifySignInCode stored in sessionStorage — same priority order
  // (show_reset_popup > multiple practices > wellsoft > dashboard) that used
  // to run immediately during verify, before the user ever saw a success
  // screen to click through.
  continueAfterSignIn = () => {
    store.dispatch.modal.toggleClose(false);
    const { history } = this.props;
    const totalPractices = JSON.parse(sessionStorage.getItem('totalPractice') || '0');
    if (JSON.parse(sessionStorage.getItem('show_reset_popup') || 'false')) {
      store.dispatch.login.changePasswordFlowDisplay();
    } else if (totalPractices > 1) {
      store.dispatch.login.selectPracticeView();
    } else if (sessionStorage.getItem('practiceSelectedMgmt') === 'wellsoft') {
      history.push('/my_health');
    } else {
      history.push(sessionStorage.getItem('path') || '/');
    }
  };
  // Every "Back"/exit button in the sign-in-with-code and find-account
  // wizards routes through this instead of dispatching model/trigger
  // directly (see ModalParser.ts's dismissLoaderThen). Their Send/Verify/Save
  // buttons all set showLoader: true — that in-flight request can't actually
  // be cancelled, but clearing the loader here means leaving the step (or
  // closing/reopening the modal, since state.loader is unaffected by that)
  // doesn't leave every button on the page stuck under Layout.jsx's
  // full-screen loader waiting for a request the user has already abandoned.
  dismissLoaderAndNavigate = ({ model, trigger, param }) => {
    store.dispatch.loader.persistLoader({ persist: false });
    store.dispatch[model][trigger](param);
  };

  // Live checklist + Save-button gating for the forgotPassword flow's "New
  // password" step (step 3 of 4). Reads both password fields directly by id
  // regardless of which one changed — same reasoning checkForEmptyInput uses
  // for email+password, since either field can flip whether they now match.
  updateNewPasswordStep = modalId => {
    const newPassword = document.getElementById(`${modalId}NewPasswordInput`)?.value || '';
    const confirmPassword = document.getElementById(`${modalId}ConfirmPasswordInput`)?.value || '';
    const requirements = {
      Length: newPassword.length >= 8,
      Case: /[a-z]/.test(newPassword) && /[A-Z]/.test(newPassword),
      Number: /\d/.test(newPassword) && /[^A-Za-z0-9]/.test(newPassword),
    };
    Object.entries(requirements).forEach(([key, met]) => {
      const icon = document.getElementById(`${modalId}Requirement${key}Icon`);
      if (icon) icon.style.color = met ? '#22c55e' : '#cfd8dc';
    });
    store.dispatch.button.enableButton({
      btn: `${modalId}SavePasswordBtn`,
      complete: Object.values(requirements).every(Boolean) && confirmPassword.length > 0 && confirmPassword === newPassword,
    });
  };
  checkNewPassword = ({ id }) => this.updateNewPasswordStep(id.replace(/NewPasswordInput$/, ''));
  checkConfirmPassword = ({ id }) => this.updateNewPasswordStep(id.replace(/ConfirmPasswordInput$/, ''));
  // Calls the real update_password_otp mutation and only advances to
  // nextModalId once that comes back successful — same shape as
  // sendSignInCode/verifySignInCode above.
  updatePasswordOtp = async ({ newPasswordId, nextModalId }) => {
    const input = document.getElementById(newPasswordId);
    const proposedPassword = input && input.value;
    if (!proposedPassword) return;
    // The id_token verifySignInCode captured when it advanced here — this
    // modal's own id is the key both sides use (see the NewPassword branch
    // in verifySignInCode above).
    const modalId = newPasswordId.replace(/NewPasswordInput$/, '');
    const idToken = this.state.signInCodeIdTokens[modalId];
    if (!idToken) return;
    try {
      const { data } = await this.props.client.mutate({
        mutation: UpdatePasswordOtp,
        variables: { id_token: idToken, proposed_password: proposedPassword },
      });
      if (data?.updatePasswordOtp?.status === 200) {
        store.dispatch.modal.toggleOpen(nextModalId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  recoverPassword = async e => {
    e.preventDefault();
    this.resetState();
    const regex = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
    if (e.length === 0 || regex.test(e) === false) {
      store.dispatch.button.enableButton({
        btn: 'recoverPasswordBtn',
        complete: false,
      });
    }
    const email = e.target.forgotPasswordEmail.value;
    if (!email) return;
    try {
      store.dispatch.login.showCheckmark(true);
      const { data } = await this.props.client.mutate({
        mutation: RecoverPassword,
        variables: { email },
      });
      if (data.recoverPassword === 200) {
        this.checkmarkComplete();
        store.dispatch.login.showRequestSuccess(true);
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  changePassword = async e => {
    e.preventDefault();
    // this.setState({ loading: true });
    // const currentPassword = e.target.currentPasswordB.value;
    const proposedPassword = e.target.profileSettingsNewPassword.value;

    if(this.state.loginCredentials.password === proposedPassword) {
      // this.setState({ loading: false });
      store.dispatch.toast.open({
        type: 'error',
        message: 'New Password cannot be same as your current password.',
      });
      return false;
    }

    try {
      this.setState({ loading: true });

      const { data } = await this.props.client.mutate({
        mutation: changePassword,
        variables: { input: { currentPassword: this.state.loginCredentials.password, proposedPassword, deviceIdentifier: localStorage.getItem('device_identifier') } },
      });

      if(data.changePassword.status === 200) {
        this.finishChangePassword();
        // store.dispatch.login.changePasswordFlowDisplay();
        sessionStorage.setItem('show_reset_popup', false)
        this.setState({ loading: false });

      // if (JSON.parse(sessionStorage.getItem('totalPractice')) > 1) {
      //   // Disable page loader
      //   this.setState({ loading: false });
      //   store.dispatch.login.selectPracticeView();
      // } else if(sessionStorage.getItem("practiceSelectedMgmt") === 'wellsoft') {
      //   this.props.history.push('/my_health')
      // } else {
      //   this.props.history.push(sessionStorage.getItem('path'));
      //   return true;
      // }
      }
    } catch (error) {
      console.error(error)
      this.setState({ loading: false });
      return false;
    }
  };

  savePassword = async e => {
    e.preventDefault();
    this.resetState();
    const password = e.target.newPasswordRepeat.value;
    const queryString = new URLSearchParams(this.props.location.search);
    const username = queryString.get('un');
    const code = queryString.get('confirmation_code');
    try {
      // hide new password
      store.dispatch.login.createNewPasswordView();
      // to display correct success message form schema parser
      store.dispatch.login.showResetPasswordCheckmark(true);
      store.dispatch.login.showCheckmark(true);
      const { data } = await this.props.client.mutate({
        mutation: ResetPassword,
        variables: { input: { username, code, password } },
      });
      if (data.resetPassword === 200) {
        store.dispatch.login.showRequestSuccess(true);
        this.checkmarkComplete();
        setTimeout(() => {
          store.dispatch.login.showResetPasswordComplete();
        }, 3000);
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };
  checkForEmptyInputEmail = ({ value }) => {
    const regex = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
    if (value.length === 0 || regex.test(value) === false) {
      store.dispatch.signup.setUpdatedEmail({ updatedEmail: value });
      store.dispatch.button.enableButton({
        btn: 'btnSignUpEmailUpdate',
        complete: false,
      });
    } else {
      store.dispatch.signup.setUpdatedEmail({ updatedEmail: value });
      store.dispatch.button.enableButton({
        btn: 'btnSignUpEmailUpdate',
        complete: true,
      });
    }
  };
  checkForEmptyInputOTP = ({ value }) => {
    const regex = new RegExp(/^\d{5}$/);
    if (value.length === 5 && regex.test(value)) {
      this.setState(prevState => {
        return {
          ...prevState,
          otp: value,
        };
      });
      store.dispatch.button.enableButton({
        btn: 'loginOTPVerifyBtn',
        complete: true,
      });
    } else {
      store.dispatch.button.enableButton({
        btn: 'loginOTPVerifyBtn',
        complete: false,
      });
    }
  };
  checkForEmptyInput = ({ id, value }) => {
    const regex = new RegExp(/^[A-Z0-9a-z._%+-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,64}$/);

    if (store.getState().login.newSignUpEmail) {
      document.getElementById('email').value = store.getState().login.newSignUpEmail;
      store.dispatch.login.saveNewSignUpEmail('');
    }
    const field = id === 'email' ? 'emailInputEmpty' : 'passwordInputEmpty';
    if (field === 'emailInputEmpty' && value) {
      store.dispatch.login.setEmailInputValidator(!value);
    } else if (field === 'passwordInputEmpty' && value) {
      store.dispatch.login.setPasswordInputValidator(!value);
    }
    const email = document.getElementById("email");
    const password = document.getElementById("password");
    if (email.value.length !== 0 && password.value.length !== 0) {
      if (id === 'email' && regex.test(value)) {
        const isComplete = !store.getState().login.emailInputEmpty && !store.getState().login.passwordInputEmpty;
        store.dispatch.button.enableButton({
          btn: 'btnSignIn',
          complete: isComplete,
        });
      } else if (id === 'password') {
        const isEmailValid = regex.test(document.getElementById('email').value);
        const isComplete = isEmailValid && !store.getState().login.passwordInputEmpty;
        store.dispatch.button.enableButton({
          btn: 'btnSignIn',
          complete: isComplete,
        });
      } else {
        store.dispatch.button.enableButton({
          btn: 'btnSignIn',
          complete: false,
        });
      }
    } else {
      store.dispatch.button.enableButton({
        btn: 'btnSignIn',
        complete: false,
      });
    }
  };
  
  
  handlePracticeSelect = e => {
    e.preventDefault();
    // Enable page loader
    this.setState({ loading: true });

    const practice = store.getState().radioInput;
    let executionValue = "";
      if (practice.cloverapi === true) {
        executionValue = "cloverapi";
      } else if (practice.payeezy === true) {
        executionValue = "payeezy";
      }else{
        executionValue = 'no-value'
      }
    sessionStorage.setItem('practiceSelected', practice.selectBusinessValue);
    sessionStorage.setItem('practiceSelectedName', practice.selectBusiness);
    sessionStorage.setItem('execution', executionValue);
  };
  resendOTP = async _ => {
    store.dispatch.button.enableButton({
      btn: 'twofaResendBtn',
      complete: false,
    });
    store.dispatch.settings.setTimeDuration({ duration: 300 });
    const {
      loginCredentials: { email, password },
    } = this.state;
    try {
      const device_identifier = localStorage.getItem('device_identifier');
      const { data } = await this.props.client.mutate({
        mutation: signInResendOTP,
        variables: {
          email,
          password,
          device_identifier,
        },
      });
      if (data) {
        return true;
      }
    } catch (error) {
      store.dispatch.button.enableButton({
        btn: 'twofaResendBtn',
        complete: false,
      });
      return false;
    }
  }

  forgotShowPassword = password => {
    const inputElement = document.getElementById(password.passwordId);
    const eyeIcon = document.getElementById(password.buttonId);
    const eyeShowPasswordSrc = 'https://assets.gobreeze.com/eye-password-show-svgrepo-com.svg';
    const eyeHidePasswordSrc = 'https://assets.gobreeze.com/eye-password-hide-svgrepo-com.svg';
    if (inputElement.type === 'password') {
      inputElement.type = 'text';
      eyeIcon.querySelector('img').src = eyeHidePasswordSrc;
    } else {
      inputElement.type = 'password';
      eyeIcon.querySelector('img').src = eyeShowPasswordSrc;
    }
  }
    
  forgotShowPassword = password => {
    const inputElement = document.getElementById(password.passwordId);
    const eyeIcon = document.getElementById(password.buttonId);
    const eyeShowPasswordSrc = 'https://assets.gobreeze.com/eye-password-show-svgrepo-com.svg';
    const eyeHidePasswordSrc = 'https://assets.gobreeze.com/eye-password-hide-svgrepo-com.svg';
    if (inputElement.type === 'password') {
      inputElement.type = 'text';
      eyeIcon.querySelector('img').src = eyeHidePasswordSrc;
    } else {
      inputElement.type = 'password';
      eyeIcon.querySelector('img').src = eyeShowPasswordSrc;
    }
  }

  // Accepts either a plain password field id (existing callers, e.g. the
  // main sign-in form's single "eyeIcon" toggle) or a {passwordId, buttonId}
  // pair — needed once more than one password field/toggle exists on screen
  // at once, since a bare id would always look up the first "eyeIcon".
  passwordShow = passwordIdOrParams => {
    const { passwordId, buttonId = 'eyeIcon' } =
      typeof passwordIdOrParams === 'string' ? { passwordId: passwordIdOrParams } : passwordIdOrParams;
    const inputElement = document.getElementById(passwordId);
    const eyeIcon = document.getElementById(buttonId);
    const eyeShowPasswordSrc = 'https://assets.gobreeze.com/eye-password-show-svgrepo-com.svg';
    const eyeHidePasswordSrc = 'https://assets.gobreeze.com/eye-password-hide-svgrepo-com.svg';
    const lang = localStorage.getItem('CC-Breeze-Web-language')

    const wasHidden = inputElement.type === 'password';
    inputElement.type = wasHidden ? 'text' : 'password';

    // The sign-in screen renders a SHOW/HIDE text toggle instead of the eye glyph,
    // so only swap the image when one is actually present.
    const eyeIconImage = eyeIcon && eyeIcon.querySelector('img');
    if (eyeIconImage) {
      eyeIconImage.src = wasHidden ? eyeHidePasswordSrc : eyeShowPasswordSrc;
    } else if (eyeIcon) {
      //eslint-disable-next-line no-nested-ternary
      eyeIcon.textContent = wasHidden ? lang === 'es' ? 'OCULTAR' : 'HIDE' : lang === 'es' ? 'MOSTRAR' : 'SHOW';
    }
  }
  passwordShowByName = passwordId => {
    const inputElements = document.getElementsByName(passwordId.inputName);
    const eyeIcon = document.getElementById(passwordId.buttonId);
    const eyeShowPasswordSrc = 'https://assets.gobreeze.com/eye-password-show-svgrepo-com.svg';
    const eyeHidePasswordSrc = 'https://assets.gobreeze.com/eye-password-hide-svgrepo-com.svg';
    if (inputElements.length > 0) {
      const inputElement = inputElements[0];
  
      if (inputElement.type === 'password') {
        inputElement.type = 'text';
        eyeIcon.querySelector('img').src = eyeHidePasswordSrc;
      } else {
        inputElement.type = 'password';
        eyeIcon.querySelector('img').src = eyeShowPasswordSrc;
      }
    } else {
      console.error(`No input element found with name "${passwordId}"`);
    }
  };

  authPasswordShow = passwordBtn => {
    const inputElement = document.getElementById(passwordBtn.passwordId);
    const eyeIcon = document.getElementById(passwordBtn.buttonId);
    const eyeShowPasswordSrc = 'https://assets.gobreeze.com/eye-password-show-svgrepo-com.svg';
    const eyeHidePasswordSrc = 'https://assets.gobreeze.com/eye-password-hide-svgrepo-com.svg';
    
    if (inputElement.type === 'password') {
      inputElement.type = 'text';
      eyeIcon.querySelector('img').src = eyeHidePasswordSrc; // Change the src to hide password image
    } else {
      inputElement.type = 'password';
      eyeIcon.querySelector('img').src = eyeShowPasswordSrc; // Change the src to show password image
    }
  }

  passwordShownBtn = () => {
    const inputElement3 = document.getElementById('password');
    if(inputElement3 !== null){
      const inputValue3 = inputElement3.value;
      const buttonElement3 = document.getElementById('eyeIcon');
      const imgElement3 = buttonElement3 && buttonElement3.querySelector('img');
      // Only the eye glyph is hidden while the field is empty — the SHOW/HIDE text
      // toggle on the sign-in screen stays visible, as in the design.
      if(imgElement3){
        if(inputValue3 === ''){
          imgElement3.style.display = 'none';
          buttonElement3.style.pointerEvents = 'none'
        }else{
          imgElement3.style.display = 'block';
          buttonElement3.style.pointerEvents = 'all'
        }
      }
      if(store.getState.formGroup?.change?.value){
        console.log(store.getState.formGroup.change.value);
      }
    } else {      
      const inputElement = document.getElementById('profileSettingsNewPassword');
      const inputElement2 = document.getElementById('profileSettingsRepeatNewPassword');
      if(inputElement !== null || inputElement2 !== null){
        const inputValue = inputElement.value;
        const inputValue2 = inputElement2.value;
        const buttonElement = document.getElementById('eyeIcon');
        const buttonElement2 = document.getElementById('eyeIcon2');
        const imgElement = buttonElement.querySelector('img');
        const imgElement2 = buttonElement2.querySelector('img');
        if(inputValue === ''){
          // imgElement.style.display = 'none';
          // buttonElement.style.pointerEvents = 'none'
        }else{
          imgElement.style.display = 'block';
          buttonElement.style.pointerEvents = 'all'
        }
        if(inputValue2 === ''){
          // imgElement2.style.display = 'none';
          // buttonElement2.style.pointerEvents = 'none'
        }else{
          imgElement2.style.display = 'block';
          buttonElement2.style.pointerEvents = 'all'
        }
      }
    }
  }

  // Live-colors ChangePassword.ts's static requirement checklist (cyclops
  // only declares the icons/labels, not their met/unmet state) as the user
  // types — mirrors passwordShownBtn's pattern of reading the DOM value
  // straight off componentDidUpdate rather than a controlled-input handler,
  // since Input's onChange only dispatches to the formGroup redux model.
  checkPasswordRequirements = () => {
    const newPasswordInput = document.getElementById('profileSettingsNewPassword');
    if (newPasswordInput === null) return;
    const repeatPasswordInput = document.getElementById('profileSettingsRepeatNewPassword');
    const password = newPasswordInput.value;
    const met = '#5bd064';
    const unmet = '';

    const setIconColor = (iconId, isMet) => {
      const icon = document.getElementById(iconId);
      if (icon) icon.style.color = isMet ? met : unmet;
    };

    setIconColor('changePasswordRequirementLengthIcon', password.length >= 8);
    setIconColor('changePasswordRequirementNumberIcon', /\d/.test(password));
    setIconColor('changePasswordRequirementUppercaseIcon', /[A-Z]/.test(password));
    setIconColor('changePasswordRequirementSymbolIcon', /[!@\][#?\\\-$"%^&*/.}{)(,><':;|_~`]/.test(password));

    if (repeatPasswordInput) {
      const passwordsMatch = password !== '' && password === repeatPasswordInput.value;
      setIconColor('changePasswordMatchIndicatorIcon', passwordsMatch);
    }
  }
  render() {
    const {
      location,
      login: {
        screens,
        screens: { loginScreen, forgotPassword, mobilePrompt, mobilePromptConnectedSuccess, labels, selectPractice },
        showForgotPassword,
        showSelectPractice,
        resetPasswordComplete,
      },
    } = this.props;
    if (isEmpty(screens)) return null;
    if (Session.hasTokens() && sessionStorage.getItem('practiceSelected') && sessionStorage.getItem('practiceSelectedMgmt') !== 'wellsoft') return <Redirect to={location.pathname} />;
    else if(Session.hasTokens() && sessionStorage.getItem('practiceSelected') && sessionStorage.getItem('practiceSelectedMgmt') === 'wellsoft') return <Redirect to='/my_health' />;
    if (resetPasswordComplete) {
      if (location.search.includes('confirmation_code')) {
        store.dispatch.login.showCheckmark(false);
        return <Redirect to="/" />;
      }
    }
    let loginSchema = loginScreen;
    if (
      !this.state.inviteCode &&
      isMobileDevice() &&
      (getMobileDevice() === Utilities.GOOGLE || getMobileDevice() === Utilities.APPLE)
    ) {
      loginSchema = mobilePrompt;
    } else if (showForgotPassword) {
      loginSchema = forgotPassword;
    } else if (showSelectPractice) {
      loginSchema = selectPractice;
    } else if (this.state.connectedToMultiProviders) {
      loginSchema = mobilePromptConnectedSuccess;
    }
    return (
      <>
        <LoginContext.Provider
          value={{
            handleSubmitOTP: this.handleSubmitOTP,
            resendOTP: this.resendOTP,
            checkForEmptyInputOTP: this.checkForEmptyInputOTP,
          }}
        >
          <SchemaParser schema={[this.state.otpModal]} />
          <Login
            props={{
              ...this.props,
              handleSubmit: this.handleSubmit,
              recoverPassword: this.recoverPassword,
              savePassword: this.savePassword,
              changePassword: this.changePassword,
              handlePracticeSelect: this.handlePracticeSelect,
              loadCheckmarkComplete: this.state.loadCheckmarkComplete,
              loadCrossIncomplete: this.state.loadCrossIncomplete,
              cross: this.state.cross,
              checkmark: this.state.checkmark,
              errorMessage: this.state.errorMessage,
              loading: this.state.loading,
              isMobile: isMobileDevice(),
              isMobileSignup: this.isMobileSignup(),
              loginSchema,
              postSignUp: parseParams(this.props).confirmed,
              labels,
              loginScreen,
              showSelectPractice,
              selectPractice,

            }}
          />
          <ToastContainer />
        </LoginContext.Provider>
      </>
    );
  }
}
const mapStateToProps = ({ login, error }) => ({
  login,
  error,
  rightSide: login.rightSide,
  isMobile: isMobileDevice(),
});

const enhancer = compose(
  withRouter,
  withApollo,
  connect(mapStateToProps),
  graphql(GetLogin, {
    name: 'getLogin',
    options: props => {
      const confirmedParam = parseParams(props).confirmed;
      return {
        variables: {
          input: {
            getMobileDevice: getMobileDevice(),
            ...(confirmedParam && {
              emailConfirmed: JSON.parse(confirmedParam),
            }),
          },
        },
      };
    },
  }),
);

// LoginContainer.whyDidYouRender = true;

export default enhancer(LoginContainer);
